
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getDistributeBudgetDtoFormGroup() {
return new FormGroup({
    budgetAccountId: new FormControl<number | undefined>(undefined, [Validators.required]),
    year: new FormControl<number | undefined>(undefined, [Validators.required]),
    totalValue: new FormControl<number | undefined>(undefined, [Validators.required]),
    valueType: new FormControl<any | undefined>(undefined, [Validators.required]),
    businessdivisionId: new FormControl<number | undefined>(undefined),
    businessdivisionIds: new FormControl<Array<number> | undefined>([]),
    businessunitId: new FormControl<number | undefined>(undefined),
})
;
}
      